import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import config from '../../config/appConfig';

export default function SuperAdminLogin({ onLogin }) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        if (!email || !password) {
            toast.warning("Por favor, completa todos los campos");
            return;
        }

        setLoading(true);
        try {
            const res = await axios.post(config.api_url + '/api/bimba/login', {
                email: email.trim(),
                password: password.trim()
            });

            if (res.data && res.data.status === "success") {
                localStorage.setItem("superadmin_token", res.data.token);
                localStorage.setItem("superadmin_user", JSON.stringify({
                    nombre: res.data.nombre,
                    email: res.data.email,
                    rol: res.data.rol
                }));
                toast.success("¡Bienvenido, " + res.data.nombre + "!");
                onLogin(res.data);
            } else {
                toast.error("❌ " + (res.data.message || "Error de acceso"));
            }
        } catch (err) {
            console.error("Error SuperAdmin Login:", err);
            if (err.response) {
                toast.error("❌ " + ((err.response.data && err.response.data.message) || "Error del servidor"));
            } else if (err.request) {
                toast.error("⚠️ No se pudo conectar con el servidor.");
            } else {
                toast.error("⚠️ Error inesperado: " + err.message);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="superadmin-login-wrapper">
            <style>{`
                .superadmin-login-wrapper {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    min-height: 100vh;
                    width: 100vw;
                    position: fixed;
                    top: 0;
                    left: 0;
                    padding: 20px;
                    box-sizing: border-box;
                    background: linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%);
                    overflow: hidden;
                    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
                }
                .superadmin-login-wrapper::before {
                    content: '';
                    position: absolute;
                    width: 600px;
                    height: 600px;
                    border-radius: 50%;
                    background: radial-gradient(circle, rgba(102,126,234,0.18) 0%, transparent 70%);
                    top: -200px;
                    right: -200px;
                    animation: superadmin-float 8s ease-in-out infinite;
                }
                .superadmin-login-wrapper::after {
                    content: '';
                    position: absolute;
                    width: 400px;
                    height: 400px;
                    border-radius: 50%;
                    background: radial-gradient(circle, rgba(118,75,162,0.14) 0%, transparent 70%);
                    bottom: -100px;
                    left: -100px;
                    animation: superadmin-float 10s ease-in-out infinite reverse;
                }
                @keyframes superadmin-float {
                    0%, 100% { transform: translate(0, 0) scale(1); }
                    50% { transform: translate(30px, -30px) scale(1.1); }
                }
                .superadmin-input-wrap {
                    display: flex;
                    align-items: center;
                    background: #fff;
                    border: 1.5px solid #e5e7eb;
                    border-radius: 10px;
                    padding: 0 14px;
                    transition: border-color 0.2s;
                }
                .superadmin-input-wrap:focus-within {
                    border-color: #667eea;
                }
                .superadmin-input {
                    flex: 1;
                    border: none;
                    outline: none;
                    padding: 14px 10px;
                    fontSize: 14px;
                    background: transparent;
                    color: #1a1a2e;
                }
                .superadmin-input::placeholder {
                    color: #9ca3af;
                }
                .superadmin-submit-btn {
                    width: 100%;
                    border: none;
                    color: #fff;
                    font-weight: 600;
                    background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
                    transition: transform 0.2s ease, box-shadow 0.2s ease;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                }
                .superadmin-submit-btn:hover:not(:disabled) {
                    transform: translateY(-1px);
                    box-shadow: 0 8px 20px rgba(102,126,234,0.35);
                }
                .superadmin-submit-btn:disabled { opacity: 0.7; cursor: not-allowed; }
                @keyframes spin { to { transform: rotate(360deg); } }
            `}</style>

            {/* TARJETA DE LOGIN */}
            <div style={{
                zIndex: 2,
                width: '100%',
                maxWidth: '420px',
                borderRadius: '28px',
                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                backdropFilter: 'blur(20px)',
                border: 'none',
                padding: '40px 30px',
                boxShadow: '0 25px 60px rgba(0,0,0,0.3), 0 0 0 1px rgba(255,255,255,0.1)',
                textAlign: 'center'
            }}>
                {/* ICONO */}
                <div className="mb-3" style={{
                    width: '64px', height: '64px', margin: '0 auto 16px',
                    borderRadius: '18px', display: 'flex', alignItems: 'center', justifyContent: 'center',
                    background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
                    boxShadow: '0 8px 20px rgba(102,126,234,0.25)'
                }}>
                    <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                    </svg>
                </div>

                <h2 style={{ fontSize: '22px', fontWeight: '700', color: '#1a1a2e', margin: '0 0 24px' }}>
                    Panel Administrativo
                </h2>

                <form onSubmit={handleLogin}>
                    <div style={{ marginBottom: '16px' }} className="superadmin-input-wrap">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                            <polyline points="22,6 12,13 2,6"/>
                        </svg>
                        <input
                            type="email"
                            className="superadmin-input"
                            placeholder="Correo electrónico"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            disabled={loading}
                        />
                    </div>

                    <div style={{ marginBottom: '24px' }} className="superadmin-input-wrap">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                            <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                        </svg>
                        <input
                            type="password"
                            className="superadmin-input"
                            placeholder="Contraseña"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            disabled={loading}
                        />
                    </div>

                    <button type="submit" className="superadmin-submit-btn py-3 shadow" style={{ fontSize: '16px', borderRadius: '50px', padding: '14px 24px' }} disabled={loading}>
                        {loading ? (
                            <div style={{
                                width: '18px', height: '18px',
                                border: '2px solid rgba(255,255,255,0.3)',
                                borderTopColor: '#fff',
                                borderRadius: '50%',
                                animation: 'spin 0.6s linear infinite'
                            }} />
                        ) : (
                            <>
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
                                    <polyline points="10 17 15 12 10 7"/>
                                    <line x1="15" y1="12" x2="3" y2="12"/>
                                </svg>
                                Ingresar
                            </>
                        )}
                    </button>
                </form>
            </div>
        </div>
    );
}
